import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Splits = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Splits' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,22 L23,22 L23,2 L1,2 L1,22 Z M8,2 L8,22 L8,2 Z M16,2 L16,22 L16,2 Z' />
  </StyledIcon>
);
